import * as React from 'react';

import {PaginationControls} from '../pagination/pagination-controls';

type Props = {
    collectionLength: number;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    displayPageControls?: boolean;
    disableButtons?: boolean;
    disableNextButton?: boolean;
    shouldShowTotal?: boolean;
    onPageChange: (arg1: number) => any;
};

export function PaginationControlsBar(props: Props) {
    const {
        collectionLength,
        currentPage,
        pageSize,
        totalPages,
        displayPageControls = false,
        onPageChange,
    } = props;

    const range = getShownRange(
        collectionLength,
        currentPage,
        pageSize,
        totalPages,
        props.shouldShowTotal
    );

    return (
        <>
            <div>{range}</div>
            <PaginationControls
                selectedPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                displayPageControls={displayPageControls}
                hasFlexGrow={false}
                disableButtons={props.disableButtons}
                disableNextButton={props.disableNextButton}
            />
        </>
    );
}

function getShownRange(
    count: number,
    page: number,
    pageSize: number,
    totalPages: number,
    shouldShowTotal = true
) {
    if (count === 0) {
        return '';
    }

    let endOfRange = page * pageSize;
    if (totalPages === page) {
        endOfRange = count;
    }

    const startOfRange = (page - 1) * pageSize + 1;

    if (shouldShowTotal) {
        return `${startOfRange.toLocaleString()}-${endOfRange.toLocaleString()} of ${count.toLocaleString()}`;
    }

    return `${startOfRange.toLocaleString()}-${endOfRange.toLocaleString()}`;
}
